import { render, staticRenderFns } from "./zj-roll.vue?vue&type=template&id=0e2929e8&scoped=true&"
import script from "./zj-roll.vue?vue&type=script&lang=js&"
export * from "./zj-roll.vue?vue&type=script&lang=js&"
import style0 from "./zj-roll.vue?vue&type=style&index=0&id=0e2929e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2929e8",
  null
  
)

component.options.__file = "zj-roll.vue"
export default component.exports